import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { JwtService } from '@app/core/services/jwt.service';
import { throwError } from 'rxjs';
import { catchError } from "rxjs/internal/operators";
@Injectable()
export class ApiService {
  constructor(
    private http: HttpClient,
    private jwtService: JwtService
  ) { }
  private formatErrors(error: any) {
    return throwError(error.error);
  }
  postToAuthServer(path: string, body: Object = {}): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-type': 'application/x-www-form-urlencoded; charset=utf-8',
        'Authorization': 'Basic ' + btoa("trusted-app:spring-security-oauth2-read-write-client-password1234")
      })
    };

    var otpt = this.http.post(
      `${environment.auth_server_url}${path}`,
      body,
      httpOptions
    ).pipe(catchError(this.formatErrors));
    return otpt;
  }
  get(path: string, params: HttpParams = new HttpParams()): Observable<any> {
    return this.http.get(`${environment.api_url}${path}`, { params })
      .pipe(catchError(this.formatErrors));
  }

  getWithHeaders(path: string): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-type': 'application/x-www-form-urlencoded; charset=utf-8',
        'Authorization': 'Bearer ' + this.jwtService.getToken()
      })
    };
    return this.http.get(`${environment.api_url}${path}`, httpOptions)
      .pipe(catchError(this.formatErrors));
  }
  getPDF(path: string): any {
    return this.http.get(
      `${environment.api_url}${path}`,
      { responseType: 'blob' }
    ).pipe(catchError(this.formatErrors));
  }
  put(path: string, body: Object = {}): Observable<any> {
    return this.http.put(
      `${environment.api_url}${path}`,
      JSON.stringify(body)
    ).pipe(catchError(this.formatErrors));
  }
  post(path: string, body: Object = {}): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-type': 'application/json',
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + this.jwtService.getToken()
      })
    };
    return this.http.post(
      `${environment.api_url}${path}`,
      JSON.stringify(body),
      httpOptions
    ).pipe(catchError(this.formatErrors));
  }
  delete(path): Observable<any> {
    return this.http.delete(
      `${environment.api_url}${path}`
    ).pipe(catchError(this.formatErrors));
  }
}
